export default "__VITE_PUBLIC_ASSET__2eddda1e__"